module.exports = __webpack_public_path__ + "img/semanteme.6b51390a.png";